import { DataGrid, GridColDef, DataGridProps, csCZ, GridColumnHeaderParams } from '@mui/x-data-grid';
import { styled } from '@mui/material/styles';

import { langStore } from "~/stores/lang";
import { ALL_LANGS, PAGE_SIZE, PAGE_SIZE_OPTS } from '~/const';

export const DataGridWithoutOutline = styled(DataGrid)<DataGridProps>(() => ({
	"& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
		outline: "none !important",
	},
	"& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus": {
		outline: "none !important",
	},
}));

interface IMyDataGrid extends DataGridProps {
	columns: GridColDef[];
	rows: any;
}

export default function MyDataGrid({
	columns = [],
	rows = [],
	...props
}: IMyDataGrid) {
	const { curLangKey } = langStore(langState => ({
		curLangKey: langState.data.lang,
	}));
	let localeText = null;

	if (curLangKey === ALL_LANGS.czech) {
		localeText = csCZ.components.MuiDataGrid.defaultProps.localeText;
	}

	return <DataGridWithoutOutline
		rows={rows}
		columns={columns}
		pageSize={PAGE_SIZE}
		rowsPerPageOptions={PAGE_SIZE_OPTS}
		{ ...localeText ? { localeText } : {} }
		{ ...props }
	/>;
}

export function renderStrongHeader(params: GridColumnHeaderParams) {
	return <strong>
		{ params.colDef.headerName }
	</strong>;
}
